export enum Role {
  Patient = "patient",
  Doctor = "doctor",
  Agent = "agent"
}

export enum CallStatusEnum {
  CALL_INITIATED = "CALL_INITIATED",
  SEARCHING_FOR_AVAILABLE_USER = "SEARCHING_FOR_AVAILABLE_USER",
  NO_USERS_AVAILABLE = "NO_USERS_AVAILABLE",
  SESSION_STARTED = "SESSION_STARTED",
  SESSION_ENDED = "SESSION_ENDED",
  PATIENT_CANCELED = "PATIENT_CANCELED"
}

export enum CancelCallTypeStatusEnum {
  CALLBACK = "callback",
  PATIENT_CANCELED = "cancel"
}

export enum DeclineCallReasonsEnum {
  CANCELLED_CALL = "Canceled the call",
  CALL_MISSED = "Call missed"
}
export enum RejectionReasonsEnum {
  CANCELLED_CALL = "cancelled",
  CALL_MISSED = "missed"
}
